import React from 'react';

import Byline from '@components/Byline';
import LazyImgixImage from '@components/LazyImgixImage';
import { useAppContext } from '@contexts/AppContext';
import useEventTracking from '@hooks/useEventTracking';
import { article_path, highlight_path } from '@routes';
import { ClickTarget, TrackingLocation, click } from '@tracking';
import { getArticleImgSrc } from '@utils/images';

const GraphicsSearchPageFeaturedArticle = ({ dataArticle }) => {
  const { trackEvent } = useEventTracking({
    location: TrackingLocation.FeaturedArticle,
  });
  const { env } = useAppContext();

  const { authors, id, highlight, picture, publishedAt, subTitle, title } = dataArticle;

  return (
    <article className="graphics__article relative grid w-full grid-cols-1 gap-20 border-0 border-b border-solid border-grayscale-charcoal pb-36 sm:grid-cols-3 sm:gap-56 sm:pb-32 md:col-span-3 lg:border-b-0 lg:border-r lg:pr-32">
      <div className="order-2 flex flex-col justify-center sm:order-1">
        {highlight && (
          <span className="block font-suisse-intl-mono text-overline-md font-normal text-primary-magenta">
            <a
              href={highlight_path(highlight)}
              onClickCapture={() =>
                trackEvent(click({ clickTarget: ClickTarget.Highlight, clickText: highlight }))
              }
            >
              {highlight}
            </a>
          </span>
        )}
        <a
          href={article_path(id)}
          className="group/text graphics-featured-text-link"
          onClickCapture={() =>
            trackEvent(click({ clickTarget: ClickTarget.AnchorLink, clickText: title }))
          }
        >
          <h2 className="mb-0 mt-4 text-pretty font-suisse-works text-headline-xxs text-primary-black transition-colors duration-200 ease-in-out group-hover/text:text-primary-magenta">
            {title}
          </h2>
          <p className="mb-0 mt-8 text-pretty font-suisse-neue text-body-md font-normal">
            {subTitle}
          </p>
        </a>
        <Byline authors={authors} className="mt-8" publishedAt={publishedAt} timeFromNow />
      </div>

      <a
        className="graphics-featured-image-link group/image order-1 aspect-[16/9] w-full sm:order-2 sm:col-span-2 lg:max-w-[600px]"
        href={article_path(id)}
        onClickCapture={() =>
          trackEvent(click({ clickTarget: ClickTarget.ArticleImage, clickText: title }))
        }
      >
        <LazyImgixImage
          className="aspect-[16/9] h-auto w-full transition-transform duration-200 ease-in-out group-hover/image:scale-[1.03] motion-reduce:transition-none"
          role="presentation"
          src={getArticleImgSrc(id, picture, env)}
          wrapperClassName="!flex aspect-[16/9] w-full lg:max-w-[600px] overflow-hidden"
          visibleByDefault
        />
      </a>
    </article>
  );
};

export default GraphicsSearchPageFeaturedArticle;
